import { css, styled } from 'next-yak';

import {
  cornerRadiusL,
  cornerRadiusXL,
  scale005,
  scale220,
  spaceM,
  spaceS,
  spaceXL,
  spaceXS,
  xdlColorBackground,
  xdlColorSelected,
} from '@xing-com/tokens';

import type { CardCalloutVariant } from './card-callout.types';

const variants = {
  default: css`
    top: -${spaceXL};
  `,
  discount: css`
    top: -${spaceM};
  `,
  countdown: css`
    top: -${spaceM};
  `,
};

export const CalloutWrapper = styled.div<{
  $variant: CardCalloutVariant;
}>`
  display: flex;
  position: absolute;
  right: ${spaceXL};
  z-index: 0;

  ${({ $variant }) => {
    switch ($variant) {
      case 'default':
        return variants.default;
      case 'discount':
        return variants.discount;
      case 'countdown':
        return variants.countdown;
      default:
        return variants.default;
    }
  }}
`;

export const DiscountBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  background: ${xdlColorBackground};
  border: ${scale005} solid ${xdlColorSelected};
  border-end-end-radius: ${cornerRadiusXL};
  border-end-start-radius: ${cornerRadiusXL};
  border-start-end-radius: ${cornerRadiusL};
  border-start-start-radius: ${cornerRadiusL};
  padding: ${spaceS};
  width: ${scale220};
  margin-left: -${spaceM};
  z-index: -1;
`;

export const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
  padding-bottom: ${spaceXS};
  text-align: center;
`;
